import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaTrash, FaEdit, FaArrowLeft } from "react-icons/fa";
import {
  getAssignedTeams,
  removeSalesFromTM,
} from "../../services/teamService";
import MasterLayout from "../../masterLayout/MasterLayout";
import { toast } from "react-toastify";

const ViewTeamLayer = () => {
  const { id } = useParams(); // tm_id
  const navigate = useNavigate();
  const [team, setTeam] = useState(null);

  useEffect(() => {
    loadTeam();
  }, [id]);

  const loadTeam = async () => {
    const res = await getAssignedTeams(id);
    if (res.status === "success") setTeam(res.data);
  };

  const removeSales = async (sales_id) => {
    if (!window.confirm("Remove this Sales Executive?")) return;

    const res = await removeSalesFromTM({
      tm_id: id,
      sales_id,
    });

    if (res.status === "success") {
      toast.success("Sales removed");
      loadTeam();
    }
  };

  if (!team) return null;

  return (
    <MasterLayout>
      <div className="user-list-wrapper">
        <div className="user-list-card">

          {/* HEADER */}
          <div className="list-header">
            <h5>{team.tm_name} - Team Manager</h5>

            <div style={{ display: "flex", gap: "10px" }}>
              {/* UPDATE BUTTON */}
              <button
                className="btn-primary"
                onClick={() => navigate(`/add-assign/${id}`)}
              >
                <FaEdit /> Update
              </button>

              {/* BACK BUTTON */}
              <button
                className="btn-secondary"
                onClick={() => navigate("/assign-list")}
              >
                <FaArrowLeft /> Back
              </button>
            </div>
          </div>

          {/* TABLE */}
          <table className="user-table">
            <thead>
              <tr>
                <th>Name Sales Executive</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {team.sales.length === 0 ? (
                <tr>
                  <td colSpan="4" className="no-data">
                    No sales assigned
                  </td>
                </tr>
              ) : (
                team.sales.map((s) => (
                  <tr key={s.id}>
                    <td>{s.name}</td>
                    <td>{s.email}</td>
                    <td>{s.mobile}</td>
                    <td>
                      <button onClick={() => removeSales(s.id)}>
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

        </div>
      </div>
    </MasterLayout>
  );
};

export default ViewTeamLayer;
